import { MapPin } from "lucide-react";
import { SITE } from "../data/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const About = () => (
    <section id="about" className="py-16 sm:py-24 lg:py-32" data-testid="about-section">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-8 lg:grid-cols-[1.1fr_0.9fr] lg:px-16">
            <div>
                <SectionHeading
                    chapter="10"
                    kicker="About 033 Digital"
                    title="Marketing that grows businesses — as one connected system."
                    testid="about-heading"
                />
                <Reveal delay={0.15}>
                    <div className="mt-6 space-y-5 text-sm leading-relaxed text-brand-muted sm:text-base">
                        <p>
                            Most local businesses don't fail at marketing because they do too little. They fail because the
                            pieces don't connect: a Google profile here, a website there, a WhatsApp number nobody watches,
                            reviews nobody asks for.
                        </p>
                        <p>
                            033 Digital was built to fix exactly that. We turn fragmented digital marketing into a single
                            growth system — one that attracts customers, captures enquiries, converts bookings, collects
                            reviews and reconnects with the customers you already have.
                        </p>
                        <p>
                            We're practical about it. No jargon, no inflated promises, no invented case studies. We find
                            where your customer journey leaks, fix it piece by piece, and measure honestly.
                        </p>
                    </div>
                </Reveal>
                <Reveal delay={0.2}>
                    <p className="mt-8 flex items-center gap-2 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-brand-orange">
                        <MapPin size={14} aria-hidden="true" />
                        {SITE.location}
                    </p>
                </Reveal>
            </div>
            <Reveal delay={0.1}>
                <div className="rounded-3xl border border-brand-brown/10 bg-white p-6 shadow-[0_30px_60px_-24px_rgba(53,24,13,0.25)]">
                    <img
                        src={SITE.logoFull}
                        alt="033 Digital — official logo with the Get Found, Get Booked, Get Growing promise and Kolkata heritage mark"
                        className="w-full rounded-2xl"
                        width="480"
                        height="480"
                        loading="lazy"
                        data-testid="about-logo"
                    />
                </div>
            </Reveal>
        </div>
    </section>
);
